import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Unidade"
}, "Unidade", -1)
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Possui Variações"
}, "Possui Variações", -1)
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_unidade = _resolveComponent("selecionar-unidade")!
  const _component_selecionar_tipo_produto = _resolveComponent("selecionar-tipo-produto")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_categoria = _resolveComponent("selecionar-categoria")!
  const _component_selecionar_marca = _resolveComponent("selecionar-marca")!
  const _component_selecionar_origem_mercadoria = _resolveComponent("selecionar-origem-mercadoria")!
  const _component_selecionar_ncm = _resolveComponent("selecionar-ncm")!
  const _component_selecionar_genero = _resolveComponent("selecionar-genero")!
  const _component_selecionar_cest = _resolveComponent("selecionar-cest")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_form_item, {
          label: "Descrição",
          class: "ss-margin-campos",
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              maxlength: "250",
              class: "ant-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedProduto.descricao) = $event))
            }, null, 512), [
              [_vModelText, _ctx.computedProduto.descricao]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_form_item, {
          class: "ss-margin-campos",
          rules: [{ required: true }]
        }, {
          label: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_a_tooltip, {
              placement: "top",
              title: "Defina a unidade principal do produto com a unidade que você mais trabalha ou deseje apurar e controlar o seu estoque."
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, {
                  class: "ss-icone-informacao-campo",
                  nome: "informacao-campo"
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_selecionar_unidade, {
              empresas: _ctx.props.empresas,
              codigoSelecionado: _ctx.computedProduto.codigoUnidade,
              "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedProduto.codigoUnidade) = $event))
            }, null, 8, ["empresas", "codigoSelecionado"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_form_item, {
          label: "Tipo",
          class: "ss-margin-campos",
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_tipo_produto, {
              codigoSelecionado: _ctx.computedProduto.tipoProduto,
              "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedProduto.tipoProduto) = $event))
            }, null, 8, ["codigoSelecionado"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
          label: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_a_tooltip, {
              placement: "top",
              title: "Permite que você controle as variações do produto como: tamanho, cores e outras características com preço e estoque específico para cada variação."
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, {
                  class: "ss-icone-informacao-campo",
                  nome: "informacao-campo"
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_selecionar_sim_nao, {
              radioButton: true,
              valor: _ctx.computedProduto.possuiVariacao,
              "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedProduto.possuiVariacao) = $event)),
              onChange: _ctx.mudarComportamentoVariacao
            }, null, 8, ["valor", "onChange"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_form_item, {
          class: "ss-margin-campos",
          label: "Kit"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_sim_nao, {
              radioButton: true,
              valor: _ctx.computedProduto.produtoKit,
              "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedProduto.produtoKit) = $event)),
              onChange: _ctx.mudarKit,
              disabled: _ctx.computedProduto.possuiVariacao
            }, null, 8, ["valor", "onChange", "disabled"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_form_item, {
          label: "Categoria",
          class: "ss-margin-campos",
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_categoria, {
              codigosSelecionados: _ctx.computedCategoriasSelecionadas,
              "onUpdate:codigosSelecionados": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedCategoriasSelecionadas) = $event)),
              varios: true
            }, null, 8, ["codigosSelecionados"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_a_form_item, {
          label: "Marca",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_marca, {
              codigoSelecionado: _ctx.computedProduto.codigoMarca,
              "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedProduto.codigoMarca) = $event))
            }, null, 8, ["codigoSelecionado"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_a_form_item, {
          label: "Origem da mercadoria",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_origem_mercadoria, {
              codigoSelecionado: _ctx.computedProduto.origemMercadoria,
              "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedProduto.origemMercadoria) = $event))
            }, null, 8, ["codigoSelecionado"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_a_form_item, {
          label: "NCM",
          class: "ss-margin-campos",
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_ncm, {
              codigoSelecionado: _ctx.computedProduto.codigoNcm,
              "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedProduto.codigoNcm) = $event)),
              ncmSelecionado: _ctx.state.ncmSelecionado,
              "onUpdate:ncmSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.ncmSelecionado) = $event)),
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.atualizarGenero()))
            }, null, 8, ["codigoSelecionado", "ncmSelecionado"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_a_form_item, {
          label: "Gênero",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_genero, {
              codigoSelecionado: _ctx.computedProduto.genero,
              "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedProduto.genero) = $event))
            }, null, 8, ["codigoSelecionado"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_a_form_item, {
          label: "CEST",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selecionar_cest, {
              codigoSelecionado: _ctx.computedProduto.codigoCest,
              "onUpdate:codigoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedProduto.codigoCest) = $event))
            }, null, 8, ["codigoSelecionado"])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}